export default __webpack_public_path__ + "static/media/banner-170x340-bg-blue2-template.2046d824.svg";